const config = {
  "Open premium photos in a new tab": true,
};

export default config;
